import { render, staticRenderFns } from "./AddStockToShelfPopup.vue?vue&type=template&id=391bb1e3&"
import script from "./AddStockToShelfPopup.vue?vue&type=script&lang=js&"
export * from "./AddStockToShelfPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports